








import request from '@/graphql/request';
import GetFileQuery from '@/graphql/queries/getFile.gql';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  components: {
  },
})
export default class File extends Vue {
  public url: string | null = null;

  public mounted() {
    const fileId = this.$route.params.id;

    request(GetFileQuery as any, { fileId })
      .then(({ data }) => {
        this.url = `${data.getCommandFile.path}?${this.$store.getters['auth/fileQueryParams']}`;
        window.open(this.url, '_blank');
      })
      .catch(error => {
        // console.error(error);
      });
  }
}
